export default __webpack_public_path__ + "static/media/Activities.f1182806.jpeg";